import React from 'react';

function Disclaimer() {
  return (
    <div>
      <div className="header user-header">
        <div className="container">
          <h1>Disclaimer</h1>
        </div>
      </div>

      <div className="container">
        <div className="content-page">
          <p><em>Last Updated: December 31, 2025</em></p>

          <section>
            <h2>General Information</h2>
            <p>
              The information provided by Coupon Adda is for general informational purposes only. All information
              on the website is provided in good faith, however we make no representation or warranty of any kind,
              express or implied, regarding the accuracy, adequacy, validity, reliability, availability or completeness
              of any information on the website.
            </p>
          </section>

          <section>
            <h2>Coupon Accuracy</h2>
            <p>
              While we make every effort to ensure that coupon codes and deals listed on our website are accurate
              and up-to-date, we cannot guarantee:
            </p>
            <ul>
              <li>The current validity of any coupon code</li>
              <li>The success rate of any particular coupon</li>
              <li>That merchant terms and conditions will remain unchanged</li>
              <li>The availability of products or services featured in deals</li>
            </ul>
            <p>
              Coupon codes are subject to merchant terms and may expire, change, or become invalid at any time
              without prior notice.
            </p>
          </section>

          <section>
            <h2>Third-Party Websites</h2>
            <p>
              Our website contains links to third-party websites and services. We have no control over, and assume
              no responsibility for:
            </p>
            <ul>
              <li>The content, privacy policies, or practices of third-party websites</li>
              <li>Products or services offered by third-party merchants</li>
              <li>Transactions conducted on third-party platforms</li>
              <li>Any loss or damage caused by your use of third-party services</li>
            </ul>
            <p>
              We strongly advise you to review the terms and privacy policies of any third-party websites you visit.
            </p>
          </section>

          <section>
            <h2>Affiliate Relationships</h2>
            <p>
              Coupon Adda may participate in affiliate marketing programs. We may earn commissions from qualifying
              purchases made through links on our website. This does not affect the price you pay or our recommendation
              of products or services.
            </p>
          </section>

          <section>
            <h2>No Professional Advice</h2>
            <p>
              The information on this website is not intended as professional financial, legal, or business advice.
              Users should conduct their own research and consult with appropriate professionals before making any
              purchasing decisions.
            </p>
          </section>

          <section>
            <h2>Limitation of Liability</h2>
            <p>
              Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred
              as a result of the use of the website or reliance on any information provided on the website. Your use
              of the website and your reliance on any information on the website is solely at your own risk.
            </p>
            <p>
              We shall not be liable for:
            </p>
            <ul>
              <li>Failed or expired coupon codes</li>
              <li>Merchant policy changes</li>
              <li>Product quality or availability issues</li>
              <li>Disputes with third-party merchants</li>
              <li>Any financial losses incurred through your use of coupons</li>
            </ul>
          </section>

          <section>
            <h2>Pricing and Availability</h2>
            <p>
              All prices, discounts, and offers mentioned on our website are subject to change without notice.
              Merchants reserve the right to modify or cancel any promotion at their discretion. We are not
              responsible for pricing errors or changes made by merchants.
            </p>
          </section>

          <section>
            <h2>No Warranty</h2>
            <p>
              The website and all information, content, materials, and services included on or otherwise made
              available to you through this website are provided on an "as is" and "as available" basis, unless
              otherwise specified in writing.
            </p>
          </section>

          <section>
            <h2>User Responsibility</h2>
            <p>
              Users are responsible for:
            </p>
            <ul>
              <li>Verifying coupon validity before use</li>
              <li>Reading and understanding merchant terms and conditions</li>
              <li>Ensuring compliance with all applicable laws</li>
              <li>Making informed purchasing decisions</li>
              <li>Protecting their personal and financial information</li>
            </ul>
          </section>

          <section>
            <h2>Changes to Disclaimer</h2>
            <p>
              We reserve the right to modify this disclaimer at any time. Changes will be effective immediately
              upon posting on the website. Your continued use of the website following the posting of changes
              constitutes your acceptance of such changes.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have any questions regarding this disclaimer, please contact us at:
              <br />
              Email: gautammukesh935@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
